
/* injects from baggage-loader */

'use strict';

export default class LoginController {

	constructor($log, $state, $location, $stateParams, $timeout, User, Navigation, Alerts) {
		'ngInject';

		this.$log = $log;
		this.$state = $state;
		this.$location = $location;
		this.$timeout = $timeout;
		this.$stateParams = $stateParams;
		this.User = User;
		this.Navigation = Navigation;
		this.Alerts = Alerts;

		this.user = {};
		this.logging_in = false;

		this.show_password = false;
		this.password_type = "password";
		this.show_password_icon = "fa-eye";

	}

	$onInit() {

		if (this.$stateParams.email) {
			this.user.email = this.$stateParams.email;
		}

		if (this.$stateParams.sessionExpired) {
			this.Alerts.add({
				type: 'info',
				msg: 'Your current session expired, please log in to continue working.',
				timeout: 60000
			});
		}

	}

	toggleShowPassword() {
		this.show_password = !this.show_password;
		if (this.show_password) {
			this.show_password_icon = "fa-eye-slash";
			this.password_type = "text";
		} else {
			this.show_password_icon = "fa-eye";
			this.password_type = "password";
		}
		this.$log.debug('Show password', this.show_password);
	}

	/**
     * Attempts to authenticate the User and log them into the app
     */
	login() {

		// Clear any error
		this.login_error = '';
		this.logging_in = true;

		// Show progress indicator

		this.User.authenticate(this.user)
			.then(user => {

				// this.$log.debug(user);
				if (this.Navigation.getIntendedPath()) {

					// Go to intended path post login
					this.$location.path(this.Navigation.getIntendedPath(true));

				} else {

					// Go to dashboard
					this.$state.go('account.dashboard');

				}

			})
			.catch(err => {
				// Show login error
				this.login_error = err.message || err;
				this.logging_in = false;
				this.$timeout();
			});

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.controller.js